import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [email, setEmail] = useState("");
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data.posts)); }, []);

  const feature = posts[0];
  return (
    <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
      <span className="overline">The Journal</span>
      <h1 className="mt-2 text-4xl lg:text-5xl">Travel tips, local guides & owner education</h1>

      {feature && (
        <Link to="#" onClick={(e) => e.preventDefault()} className="mt-8 grid overflow-hidden rounded-3xl card-lux lift lg:grid-cols-2">
          <div className="aspect-[16/10] overflow-hidden"><img src={feature.image} alt={feature.title} className="h-full w-full object-cover" /></div>
          <div className="flex flex-col justify-center p-8">
            <span className="overline text-camel">{feature.category}</span>
            <h2 className="mt-3 text-3xl">{feature.title}</h2>
            <p className="mt-3 text-taupe">{feature.excerpt}</p>
            <div className="mt-4 text-xs text-taupe">{feature.date} · {feature.read}</div>
          </div>
        </Link>
      )}

      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {posts.slice(1).map((p, i) => (
          <div key={p.id} className="overflow-hidden rounded-3xl card-lux lift animate-fade-up" style={{ animationDelay: `${i * 50}ms` }}>
            <div className="aspect-[16/10] overflow-hidden"><img src={p.image} alt={p.title} className="h-full w-full object-cover" /></div>
            <div className="p-6">
              <span className="overline text-camel">{p.category}</span>
              <h3 className="mt-2 text-xl leading-tight text-ink">{p.title}</h3>
              <p className="mt-2 text-sm text-taupe">{p.excerpt}</p>
              <div className="mt-3 text-xs text-taupe">{p.date} · {p.read}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-14 flex flex-col items-center gap-4 rounded-3xl bg-cream p-10 text-center">
        <h2 className="text-2xl">Get travel inspiration in your inbox</h2>
        <div className="flex w-full max-w-md gap-2">
          <Input data-testid="newsletter-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="rounded-full border-black/10 bg-white" />
          <Button data-testid="newsletter-submit" onClick={() => { toast.success("Subscribed! Welcome aboard."); setEmail(""); }} className="rounded-full btn-ink px-6">Subscribe</Button>
        </div>
      </div>
    </div>
  );
}
